import { Box } from '@ltvco/refresh-lib/theme';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import NeighborhoodReportContent from './NeighborhoodReportContent';
import NeighborhoodReportHeader from './NeighborhoodReportHeader';

export const NeighborhoodReportSection = () => {
  /////////////////////////////
  // States
  /////////////////////////////
  const [searchParams] = useSearchParams();
  const rawAddress = searchParams.get('address') || '';
  let addressFromUrl = '';
  try {
    addressFromUrl = decodeURIComponent(rawAddress);
  } catch {
    addressFromUrl = rawAddress;
  }
  const [address, setAddress] = useState(addressFromUrl);

  /////////////////////////////
  // Event Handlers
  /////////////////////////////
  const handleSearch = (inputAddress: string) => {
    if (inputAddress && inputAddress.trim()) {
      setAddress(inputAddress.trim());
    }
  };
  const handleSuggestionClick = (suggestionAddress: string) => {
    handleSearch(suggestionAddress);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 0 } }}>
      <NeighborhoodReportHeader
        address={address}
        onSearch={handleSearch}
        onSuggestionClick={handleSuggestionClick}
      />
      <NeighborhoodReportContent address={address} />
    </Box>
  );
};
